import type { Site } from '../lib/cluster';
import type { Measurement, Settings } from '../lib/api';
import type { LosResult } from '../lib/los';
import type { Network } from '../lib/operators';

export type Tab = 'mappa' | 'posto' | 'misure';

export type AppState = {
  tab: Tab;
  /** Verified + manual sites (with radios merged from nearby estimates) followed by leftover estimates. */
  sites: Site[];
  settings: Settings;
  measurements: Measurement[];
  pending: Measurement[];
  selectedSiteId?: string;
  networks: Set<Network>;
  radios: Set<'5G' | '4G'>;
  showEstimated: boolean;
  los: Map<string, LosResult>;
  authExpired: boolean;
  offline: boolean;
  /** Prefill for the measurement form (from Sul posto). */
  draft?: Partial<Measurement>;
};

let state: AppState = {
  tab: 'mappa',
  sites: [],
  settings: {},
  measurements: [],
  pending: [],
  networks: new Set(['TIM', 'Vodafone', 'WindTre', 'Iliad', 'Fastweb']),
  radios: new Set(['5G', '4G']),
  showEstimated: true,
  los: new Map(),
  authExpired: false,
  offline: false,
};

const subs = new Set<(s: AppState, prev: AppState) => void>();

export const getState = () => state;

export function setState(patch: Partial<AppState>) {
  const prev = state;
  state = { ...state, ...patch };
  for (const fn of subs) fn(state, prev);
}

export function subscribe(fn: (s: AppState, prev: AppState) => void): () => void {
  subs.add(fn);
  return () => subs.delete(fn);
}

export const selectedSite = () => state.sites.find(s => s.id === state.selectedSiteId);
export const homeHeight = () => state.settings.homeHeightM ?? 8;
